export default __webpack_public_path__ + "static/media/order.8fd289bd.svg";